<div class="list-container">
  <rask-list [data]="results" [getSelectedFromRoute]="true">
    <rask-list-column header="{{ 'MOTTAGNINGSPLATS_LIST_NAMN' | translate }}"
      field="namn" width="20%" [sortable]="true">
      <ng-template let-row="row">
        <a [routerLink]="['/mottagningsplats','sverige', row.id]">
          <span data-bs-toggle="tooltip" data-placement="top" [title]="row.namn">
            {{row.namn}}
          </span>
        </a>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="{{ 'MOTTAGNINGSPLATS_LIST_MOTTAGNINGSPLATSNUMMER' | translate }}"
    field="mottagningsplatsnummer" width="10%" [sortable]="true" [nowrap]="true"></rask-list-column>
    <rask-list-column header="{{ 'MOTTAGNINGSPLATS_LIST_MOTTAGNINGSPLATSTYP' | translate }}"
    field="mottagningsplatstyp" width="10%" [sortable]="true" [nowrap]="true"></rask-list-column>
    <rask-list-column header="{{ 'MOTTAGNINGSPLATS_LIST_ANSVARIGLOGISTIKER' | translate }}"
    field="ansvarigLogistiker" width="10%" [nowrap]="true" [tooltip]="true"></rask-list-column>
    <rask-list-column header="{{ 'MOTTAGNINGSPLATS_LIST_BESKRIVNING' | translate }}" field="beskrivning"
    [nowrap]="true" [tooltip]="true"></rask-list-column>
    <rask-list-column header="Landskod" field="landskod" [nowrap]="true"></rask-list-column>
    <rask-list-column header="{{ 'MOTTAGNINGSPLATS_LIST_AKTIV' | translate }}" field="aktiv" width="5%">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
  </rask-list>
</div>